





































































































































































































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import FileUploader from "@/components/FileUploader.vue";
import Page from "@/views/Page.vue";
import ICompany from "../../models/interfaces/ICompany";
import CompaniesMixin from "../../mixins/http/CompaniesMixin";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import GeneralSettingsSelect from "@/components/GeneralSettings/Select.vue";
import GeneralSettingsMultiSelect from "@/components/GeneralSettings/MultiSelect.vue";
import { Company } from "../../models";
import { showToast } from "../../utils/RailsRoutes";
import { CompanyPayload } from "../../models/Company";
@Component({
  components: {
    Page,
    FileUploader,
    GeneralSettingsSelect,
    GeneralSettingsMultiSelect,
  },
})
export default class CompanyEdit extends Mixins(CompaniesMixin) {
  private company: CompanyPayload = null;
  private countries: Array<{ id: string; fullName: string }> = [];
  static readonly updateCompanyTag = "update_company_tag";
  @RegisterHttp(CompanyEdit.updateCompanyTag)
  updateCompanyRequest: RequestData;

  static readonly getCompanyTag = "get_company_tag";
  @RegisterHttp(CompanyEdit.getCompanyTag)
  getCompanyRequest: RequestData;

  private logo = null;
  private newLogo = null;
  private emailError = false;
  private emailRegExp =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  get emailValid() {
    return this.emailRegExp.test(this.company.email);
  }

  mounted() {
    this.loadCompany();
  }

  get loading() {
    return this.updateCompanyRequest?.loading;
  }

  get valid() {
    return (
      this.company?.name &&
      this.company?.businessName &&
      this.company?.vatNumber &&
      this.company?.countryIds?.length &&
      this.company?.address &&
      this.company?.email &&
      this.emailValid
    );
  }

  get countryOptions() {
    return this.countries.map((o) => {
      return { id: o.id, name: o.fullName };
    });
  }

  loadCompany() {
    this.getCompany(this.$route.params.id, CompanyEdit.getCompanyTag).then(
      (resp) => {
        this.company = CompanyPayload.fromCompany(resp);
        this.countries = resp.countries;
        this.logo = { url: this.company.logo };
      },
      (err) => {}
    );
  }

  get url() {
    return this.newLogo?.url || this.logo?.url;
  }

  uploadPayload() {
    let payload = new FormData();
    for (const id of this.company.countryIds) {
      payload.append("country_ids[]", id);
    }
    delete this.company.countryIds;
    delete this.company.slug;
    delete this.company.logo;
    for (const key in this.company) {
      if (this.company[key] !== null) {
        payload.append(key, this.company[key]);
      }
    }
    if (this.newLogo) {
      payload.append("logo", this.newLogo.file);
    }
    return payload;
  }

  onCountriesChanged(data) {
    const key = "countryIds";
    this.company[key] = data[key];
  }

  openFiles() {
    const file = (this.$refs.upload as any).openFileBrowser();
  }

  onGeneralSettingChanged(key: string, value) {
    this.company[key] = value;
  }

  onCreate() {
    const payload = this.uploadPayload();
    this.updateCompany(
      this.company.id,
      payload,
      CompanyEdit.updateCompanyTag
    ).then(
      (resp) => {
        showToast(`Company ${resp.name} updated successfully`);
        this.$router.back();
      },
      (err) => {
        const message = err?.response?.data?.message || err.message;
        showToast(
          `An error occurred while updating ${this.company.name}. ${message}`,
          {
            type: "error",
          }
        );
      }
    );
  }
}
